import {
  renderCustomField,
  renderDefaultValueField,
  renderMultiselectField,
  renderNumberField,
  renderRadioField,
  renderSwitchField,
  renderTextField,
} from "./basic-fields";
import {
  renderDataCenterField,
  renderFileTypesField,
  renderLocalListField,
} from "./list-fields";
import { renderSelectField } from "./select-fields";
import type { RenderFieldContext } from "./types";

export type { RenderFieldContext };

/** Maps a field's configured type to the renderer that draws it. */
export function renderFieldByType(ctx: RenderFieldContext) {
  switch (ctx.fieldConfig.type) {
    case "text":
      return renderTextField(ctx);
    case "switch":
      return renderSwitchField(ctx);
    case "select":
      return renderSelectField(ctx);
    case "number":
      return renderNumberField(ctx);
    case "multiselect":
      return renderMultiselectField(ctx);
    case "radio":
      return renderRadioField(ctx);
    case "local_list":
      return renderLocalListField(ctx);
    case "file_types":
      return renderFileTypesField(ctx);
    case "datacenter":
      return renderDataCenterField(ctx);
    case "default_value":
      return renderDefaultValueField(ctx);
    case "custom":
      return renderCustomField(ctx);
    default:
      return null;
  }
}
